module.exports = __webpack_public_path__ + "static/img/coperation-process.d16061f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/coperation-process.png
// module id = 3B/r
// module chunks = 1